var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("input", {
    attrs: { type: "checkbox" },
    domProps: { checked: _vm.value },
    on: {
      click: function ($event) {
        return _vm.checkedHandler()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }